



















































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
import { Message } from '../../CommonUtils/fixed/Message';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { applicationFormModule } from '../store/modules/ApplicationForm';
import { partialInfoModule } from '../store/modules/PartialInfo';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class PartialInfoConstruction extends ApiAccessBase {

  private isReadMode: boolean = true;
  private municipalName: string = '';

  // 共通パス
  private APP_PATH = Constants.UKETSUKE_URL + '/partial/' + applicationFormModule.GET_APP_TYPE;

  private created() {
    this.screenTitle = '個別情報登録（工事）';
    this.municipalName = partialInfoModule.GET_MUNICIPAL;
    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);

    let path = this.APP_PATH;
    path = path + '/get/' + applicationFormModule.GET_PROCESS_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID + '/' + applicationFormModule.GET_MUNICIPAL;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 使用する可変項目の設定（全て）
        this.setAllVariablecolsState();
        this.isReadMode = supervisingModule.IS_MODE_READ;
      }
    });
  }
  /**
   * 登録
   */
  private regist() {
    // form成形
    this.moldingSendForm(this.$refs.form);
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    let path = this.APP_PATH;
    path = path + '/update/' + applicationFormModule.GET_PROCESS_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID + '/' + applicationFormModule.GET_MUNICIPAL;
    // 先頭へジャンプ
    this.hrefElement('pi-const', -50);
    this.apiAccess(path, Constants.API_METHOD_POST, false, null)
    .then((result) => {
      //20250618 [ステータス変更対応] morimoto ADD Start
      //申請受付ステータスエラーの場合のみ、システムエラー画面に遷移させる。
      if (this.errorMessage.indexOf('statusSystemError')  > -1) {
        router.push({name: 'no_auth/SystemError'});
      }
      //20250618 [ステータス変更対応] morimoto ADD End
    });
  }

  /**
   * 戻る
   */
  private returnPrevious() {
    if (!this.isReadMode) {
      if (!confirm(Message.I0014)) {
        return;
      }
    }
    router.push({name: UketsukeScreenName.MUNICIPALITY_SELECT});
  }
}
